import getWidgetByName from "../requests";
import { SeriesListings } from "./entities";

const getSeriesWidget = () =>
  getWidgetByName("serieslistingwidget")
    .then(SeriesListings)

export { getSeriesWidget };
